import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div class="poem">
      <p class="poem-block text-center mb-3">* * *</p>

      <p class="poem-block mb-3">
        Вот победа по всем фронтам, -<br/>
        Только радоваться не нам:
      </p>

      <p class="poem-block mb-3">
        Со счастливой и новой Земли<br/>
        Нас, как мусор ненужный, смели.
      </p>

      <p class="poem-block mb-3">
        И осталась торжествовать<br/>
        Лишь железно-машинная рать.
      </p>

      <p class="poem-block mb-3">
        Что за счастье – Земля без народа!<br/>
        Ни воды им, ни кислорода!
      </p>

      <p class="poem-block mb-3">
        И без всяких лишних затей<br/>
        Торжествует Земля без людей!
      </p>
      
    </div>
    `
  )
}


const itemName = {
  rus: 'Вот победа по всем фронтам'
}

const item = {
  itemlink: getLink(itemName.rus),
  rus:{
    itemName: itemName.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}


export default item;